import {
  product_sales_list,
  product_sales_detail_list,
  product_sales_etc_list,
  product_sales_excel_list,
  product_sales_reload_list,
  time_sales_list,
  time_sales_excel_list,
} from "../http/SalesConn";
import { analyticeEvent, partnerText } from "utils/Utils";

//상품별 상세정보
export function fn_product_detail_pop(rootStore, type) {
  rootStore.layerStore.setLayerProductDetailView(type);
}
//누락상품매출 조회 팝업
export function fn_product_etc_pop(rootStore, type) {
  rootStore.salesStore.setSalesEtcPagingInfo("sales_page_no", 1);
  rootStore.layerStore.setLayerProductEtcView(type);
}
// 검색 레이어 조회 ( 검색어, 디테일 )
export function fn_getSearchView(rootStore) {
  return rootStore.salesStore.getSalesSearchView;
}
// 검색 레이어 열고 닫기 ( 검색어, 디테일 )
export function fn_setSearchView(rootStore, key, value) {
  fn_initSearchView(rootStore);
  rootStore.salesStore.setSalesSearchView(key, value);
}
// 검색 레이어 초기화 ( 검색어, 디테일 )
export function fn_initSearchView(rootStore) {
  rootStore.salesStore.initSalesSearchView();
}
// 검색 키값 초기화
export function fn_initSearchKey(rootStore) {
  rootStore.salesStore.initSearchKeyVal();
}
// 검색 상세버튼 조회
export function fn_getDetailButtonView(rootStore) {
  return rootStore.salesStore.getDetailButtonView;
}
// 검색 상세버튼 설정
export function fn_setDetailButtonView(rootStore, key, val) {
  if (key == "all" && val == true) {
    fn_initDetailButtonView(rootStore);
  }
  if (key != "all" && val == true) {
    fn_setDetailButtonView(rootStore, "all", false);
  }
  rootStore.salesStore.setDetailButtonView(key, val);
}
// 검색 상세버튼 초기화
export function fn_initDetailButtonView(rootStore) {
  rootStore.salesStore.setSalesProductChannel("전체");
  rootStore.salesStore.initDetailButtonView();
}
// 이전 검색 조건으로 초기화
export function fn_setBeforeDetailUpdate(rootStore) {
  rootStore.salesStore.setBeforeDetailUpdate();
}

// 리스트 정렬 초기화
export function fn_initSortView(rootStore) {
  rootStore.salesStore.setSortTypeStatusVal("orderByProductName", "status", false);
  rootStore.salesStore.setSortTypeStatusVal("orderBySaleAmount", "status", false);
  rootStore.salesStore.setSortTypeStatusVal("orderBySaleVolume", "status", false);
}

// 리스트 정렬 설정
export function fn_setSortVal(rootStore, key, val) {
  fn_initSortView(rootStore);
  if (key == "orderByProductName") {
    rootStore.salesStore.setSortTypeStatusVal("orderByProductName", "status", true);
  } else if (key == "orderBySaleAmount") {
    rootStore.salesStore.setSortTypeStatusVal("orderBySaleAmount", "status", true);
  } else {
    rootStore.salesStore.setSortTypeStatusVal("orderBySaleVolume", "status", true);
  }

  if (val == false && rootStore.salesStore.getSortTypeVal.viewType == "asc") {
    rootStore.salesStore.setSortTypeStatusVal(key, "viewType", "desc");
    rootStore.salesStore.setSortTypeVal("viewType", "desc");
  } else {
    rootStore.salesStore.setSortTypeStatusVal(key, "viewType", "asc");
    rootStore.salesStore.setSortTypeVal("viewType", "asc");
  }
}
// 리스트 정렬 조회
export function fn_getSortVal(rootStore) {
  return rootStore.salesStore.getSortTypeVal;
}

// 상품명검색 값 조회
export function fn_getSearchVal(rootStore) {
  return rootStore.salesStore.getProductNameSearchVal;
}
// 상품명검색 값 설정
export function fn_setSearchVal(rootStore, val) {
  rootStore.salesStore.setProductNameSearchVal(val);
}

// 상품유형설정 조회
export function fn_getProductType(rootStore) {
  return rootStore.salesStore.getProductTypeVal;
}
// 상품유형설정 설정
export function fn_setProductType(rootStore, key, val) {
  fn_initProductType(rootStore);
  if (key === "all") {
    rootStore.salesStore.setProductTypeVal("all", val);
    rootStore.salesStore.setProductTypeVal("productType", "A");
  } else if (key === "menu") {
    rootStore.salesStore.setProductTypeVal("menu", val);
    rootStore.salesStore.setProductTypeVal("productType", "M");
  } else if (key === "option") {
    rootStore.salesStore.setProductTypeVal("option", val);
    rootStore.salesStore.setProductTypeVal("productType", "O");
  }
}
// 상품유형설정 초기화
export function fn_initProductType(rootStore) {
  rootStore.salesStore.searchProductType();
}
// 총수량금액 초기화
export function fn_initTotalVal(rootStore) {
  rootStore.salesStore.searchTotalSalesVal();
}
// 정렬 초기화
export function fn_initSortTypeVal(rootStore) {
  rootStore.salesStore.searchSortTypeVal();
}
// 가격유형설정 조회
export function fn_getPriceType(rootStore) {
  return rootStore.salesStore.getPriceTypeVal;
}
// 가격유형설정 설정
export function fn_setPriceType(rootStore, key, val) {
  fn_initPriceType(rootStore);
  if (key === "all") {
    rootStore.salesStore.setPriceTypeVal("all", val);
    rootStore.salesStore.setPriceTypeVal("productPriceType", "A");
  } else if (key === "charge") {
    rootStore.salesStore.setPriceTypeVal("charge", val);
    rootStore.salesStore.setPriceTypeVal("productPriceType", "C");
  } else if (key === "free") {
    rootStore.salesStore.setPriceTypeVal("free", val);
    rootStore.salesStore.setPriceTypeVal("productPriceType", "F");
  }
}
// 가격유형설정 초기화
export function fn_initPriceType(rootStore) {
  rootStore.salesStore.searchPriceType();
}

// 검색 날짜설정 조회
export function fn_getDateTerm(rootStore) {
  return rootStore.salesStore.getSalesDateTerm;
}
// 검색 날짜 버튼 설정
export function fn_setDateTerm(rootStore, key, val) {
  let termVal = fn_getDateTermVal(rootStore);
  rootStore.salesStore.setSalesPagingInfo("end_page_no", 1);
  rootStore.salesStore.setSalesEtcPagingInfo("end_page_no", 1);
  if (key === "today") {
    rootStore.salesStore.setSalesDateVal("start_val", termVal.today);
    rootStore.salesStore.setSalesDateVal("end_val", termVal.today);
  } else if (key === "yesterday") {
    rootStore.salesStore.setSalesDateVal("start_val", termVal.yesterday);
    rootStore.salesStore.setSalesDateVal("end_val", termVal.yesterday);
  } else if (key === "week") {
    rootStore.salesStore.setSalesDateVal("start_val", termVal.week);
    rootStore.salesStore.setSalesDateVal("end_val", termVal.today);
  } else if (key === "lastmonth") {
    rootStore.salesStore.setSalesDateVal("start_val", termVal.lastmonth);
    rootStore.salesStore.setSalesDateVal(
      "end_val",
      new Date(termVal.lastmonth.getFullYear(), termVal.lastmonth.getMonth() + 1, 0)
    );
  } else if (key === "month") {
    rootStore.salesStore.setSalesDateVal("start_val", termVal.month);
    rootStore.salesStore.setSalesDateVal("end_val", termVal.today);
  }

  fn_initDateTerm(rootStore);
  rootStore.salesStore.setSalesDateTerm(key, val);
}

// 검색 날짜 버튼 초기화
export function fn_initDateTerm(rootStore) {
  rootStore.salesStore.searchDateTerm();
}

// 버튼별 날짜 조회
export function fn_getDateTermVal(rootStore) {
  return rootStore.salesStore.getSalesDateTermVal;
}

// 상품별매출내역 상세보기 레이어 열기
export function fn_productSalesDetail(rootStore, productName) {
  product_sales_detail_list(rootStore, productName);
}

// 누락상품매출 레이어 열기
export function fn_productSalesEtcList(rootStore) {
  product_sales_etc_list(rootStore);
}

// 검색 시작일,종료일 조회
export function fn_getDateVal(rootStore) {
  return rootStore.salesStore.getSalesDateVal;
}

// 검색 시작일,종료일 설정
export function fn_setDateVal(rootStore, key, val) {
  let startVal = rootStore.salesStore.getSalesDateVal.start_val;
  let endVal = rootStore.salesStore.getSalesDateVal.end_val;

  if (key === "start_val") {
    if (endVal < val) {
      return;
    }
  } else if (key === "end_val") {
    if (val < startVal) {
      return;
    }
  }
  rootStore.salesStore.setSalesDateVal(key, val);
}

// 검색 시작일,종료일 초기화
export function fn_initDateVal(rootStore) {
  rootStore.salesStore.initSalesDateVal();
}

// 주문채널text
export function fn_setChannelText(rootStore) {
  let searchChannel = [];
  let channelTxt = "";

  for (const [key, value] of Object.entries(rootStore.salesStore.getDetailButtonView)) {
    if (value) {
      searchChannel.push(key);
    }
  }
  // 네이버 관련 채널 중복 제거 (naver와 naverBooking, naverConnect을 하나로 처리)
  const uniqueChannels = [];
  searchChannel.forEach(channel => {
    if (channel === "naver" || channel === "naverBooking") {
      if (!uniqueChannels.includes("naver")) {
        uniqueChannels.push("naver");
      }
    } else {
      uniqueChannels.push(channel);
    }
  });

  if (uniqueChannels.length != 0) {
    if (uniqueChannels.includes("all")) {
      channelTxt = "전체";
    } else {
      uniqueChannels.forEach((txt, idx) => {
        if (idx == 0) {
          channelTxt += partnerText(txt);
        } else if (idx == 1) {
          channelTxt += ", " + partnerText(txt);
        }
      });
    }
  } else {
    channelTxt = "전체";
    fn_setDetailButtonView(rootStore, "all", true);
  }

  if (uniqueChannels.length > 2) {
    let cnt = uniqueChannels.length - 2;
    channelTxt += " 외 " + cnt + "개";
  }

  rootStore.salesStore.setSalesProductChannel(channelTxt);
}

export function fn_initSalesProductAll(rootStore) {
  // 검색 레이어 초기화
  fn_initSearchView(rootStore);
  // 상세버튼 초기화
  fn_initDetailButtonView(rootStore);
  // 검색 키값 초기화
  fn_initSearchKey(rootStore);
  // 시작일 종료일 초기화
  fn_initDateVal(rootStore);
  // 검색 날짜버튼 초기화
  fn_initDateTerm(rootStore);
  // 검색 값 초기화
  fn_setSearchVal(rootStore, "");
  //가격유형 초기화
  fn_initPriceType(rootStore);
  //상품유형 초기화
  fn_initProductType(rootStore);
  //총수량금액 초기화
  fn_initTotalVal(rootStore);
  //정렬 초기화
  fn_initSortTypeVal(rootStore);
}

// 다음페이지
export function fn_salesNextPage(rootStore) {
  rootStore.salesStore.nextSalesPage();
  // 화면 재조회
  fn_salesProductPagingSearch(rootStore);
}

// 이전페이지지
export function fn_salesPrevPage(rootStore) {
  rootStore.salesStore.prevSalesPage();
  // 화면 재조회
  fn_salesProductPagingSearch(rootStore);
}

// 누락상품 다음페이지
export function fn_salesEtcNextPage(rootStore) {
  rootStore.salesStore.nextSalesEtcPage();
  product_sales_etc_list(rootStore);
}

// 누락상품 이전페이지지
export function fn_salesEtcPrevPage(rootStore) {
  rootStore.salesStore.prevSalesEtcPage();
  product_sales_etc_list(rootStore);
}

//
export function fn_salesDateMax(rootStore) {
  let startVal = rootStore.salesStore.getSalesDateVal.start_val;
  let endVal = rootStore.salesStore.getSalesDateVal.end_val;
  let maxStartDay = new Date(Date.parse(endVal) - 30 * 1000 * 60 * 60 * 24);
  let maxEndDay = new Date(Date.parse(startVal) + 30 * 1000 * 60 * 60 * 24);

  if (maxStartDay > startVal || maxEndDay < endVal) {
    rootStore.layerStore.setLayerAlertType("search_date_max");
    rootStore.layerStore.setLayerAlertView(true);
    return false;
  } else {
    return true;
  }
}

// 검색
export function fn_salesProductPagingSearch(rootStore) {
  let status = fn_salesDateMax(rootStore);
  if (status) {
    product_sales_list(rootStore);
  } else {
    let data = JSON.parse(rootStore.salesStore.getSalesProductExcelSearchList);
    rootStore.salesStore.setSalesDateVal("start_val", data.start_val);
    rootStore.salesStore.setSalesDateVal("end_val", data.end_val);
    product_sales_reload_list(rootStore);
  }
}

// 검색
export function fn_salesProductSearch(rootStore) {
  let status = fn_salesDateMax(rootStore);
  if (status) {
    fn_salesDateMax(rootStore);
    rootStore.salesStore.setSalesPagingInfo("sales_page_no", 1);
    rootStore.salesStore.setSalesEtcPagingInfo("sales_page_no", 1);
    product_sales_list(rootStore);
  } else {
    let data = JSON.parse(rootStore.salesStore.getSalesProductExcelSearchList);
    let yyyyMMddStart = String(data.startDate);
    let sYearStart = yyyyMMddStart.substring(0, 4);
    let sMonthStart = yyyyMMddStart.substring(4, 6);
    let sDateStart = yyyyMMddStart.substring(6, 9);
    let yyyyMMddEnd = String(data.endDate);
    let sYearEnd = yyyyMMddEnd.substring(0, 4);
    let sMonthEnd = yyyyMMddEnd.substring(4, 6);
    let sDateEnd = yyyyMMddEnd.substring(6, 9);

    rootStore.salesStore.setSalesDateVal(
      "start_val",
      new Date(Number(sYearStart), Number(sMonthStart) - 1, Number(sDateStart))
    );
    rootStore.salesStore.setSalesDateVal(
      "end_val",
      new Date(Number(sYearEnd), Number(sMonthEnd) - 1, Number(sDateEnd))
    );
    product_sales_reload_list(rootStore);
  }
}

// 시간대별 매출 검색
export function fn_salesTimeSearch(rootStore) {
  let status = fn_salesDateMax(rootStore);
  if (status) {
    fn_salesDateMax(rootStore);
    //rootStore.salesStore.setSalesPagingInfo("sales_page_no", 1)
    //rootStore.salesStore.setSalesEtcPagingInfo("sales_page_no", 1)
    //product_sales_list(rootStore);
  } else {
    let data = JSON.parse(rootStore.salesStore.getSalesProductExcelSearchList);
    let yyyyMMddStart = String(data.startDate);
    let sYearStart = yyyyMMddStart.substring(0, 4);
    let sMonthStart = yyyyMMddStart.substring(4, 6);
    let sDateStart = yyyyMMddStart.substring(6, 9);
    let yyyyMMddEnd = String(data.endDate);
    let sYearEnd = yyyyMMddEnd.substring(0, 4);
    let sMonthEnd = yyyyMMddEnd.substring(4, 6);
    let sDateEnd = yyyyMMddEnd.substring(6, 9);

    rootStore.salesStore.setSalesDateVal(
      "start_val",
      new Date(Number(sYearStart), Number(sMonthStart) - 1, Number(sDateStart))
    );
    rootStore.salesStore.setSalesDateVal(
      "end_val",
      new Date(Number(sYearEnd), Number(sMonthEnd) - 1, Number(sDateEnd))
    );
    //        product_sales_reload_list(rootStore);
  }
  time_sales_list(rootStore);
}

// 판매상품 매출 엑셀
export function fn_productSalesExcelList(rootStore) {
  product_sales_excel_list(rootStore);
}

// 시간대 매출 엑셀
export function fn_timeSalesExcelList(rootStore) {
  time_sales_excel_list(rootStore);
}

// 검색 레이어 조회 ( 검색어, 디테일 )
export function fn_getHelpSearchView(rootStore) {
  return rootStore.layerStore.getLayerHelpView;
}
// 검색 레이어 열고 닫기 ( 검색어, 디테일 )
export function fn_setHelpSearchView(rootStore, value) {
  rootStore.layerStore.setLayerHelpView(value);
}
